/**
 * SaleSubmission.XrayCompleteType — how strictly a sale's X-Ray protocol
 * (its SaleTemplate) is enforced at submission time, per horse age category.
 *
 * The column, the DTO and the repository write path have existed since
 * 202304261610_SalesTables, but nothing ever read the value: the settings
 * control was commented out and neither the client nor the API validated
 * against it. Every templated sale on prod is therefore still NULL, which is
 * why enforcement has to stay opt-in — 22.9% of historic submissions (775 of
 * 3,382) never covered their template and would have been rejected.
 */
export enum XrayCompleteType {
  /** All of the template's categories must be covered before submitting. */
  Complete = 1,
  /** Any number of images may be submitted. NULL behaves the same way. */
  Partial = 2,
}
